<template>
<div>
  <v-toolbar dense style=" position: fixed;">
    </v-toolbar-items>
    <v-btn class="orange darken-2 white--text" v-on:click.native="terugClicked" > <v-icon dark left>arrow_back</v-icon>Terug</v-btn>
    <v-spacer></v-spacer>
    <v-btn style="margin: 0px;" class="blue white--text" v-on:click.native="afdrukkenClicked" :disabled="loading"><v-icon dark>print</v-icon></v-btn>
    <v-btn style="margin: 0px;" class="green white--text"  v-on:click.native="opslaanClicked" :disabled="loading"><v-icon dark>save</v-icon></v-btn>
    <v-btn style="margin: 0px;" class="red white--text"  v-on:click.native="verwijderenClicked" :disabled="loading"><v-icon dark>delete</v-icon></v-btn>

  </v-toolbar>
  <div style="  height: 50px;">
  </div>

    <div class="text-xs-center elevation-12" style="width: 90%; min-width: 400px; margin-left: auto; margin-right: auto;margin-top: 20px; margin-bottom: 20px; padding: 10px;">


    <div v-if="loading">
      <div style="width: 120px; height: 120px;margin:auto; padding-top: 20px; padding-left: 20px;">
        <v-progress-circular indeterminate v-bind:size="80" v-bind:width="5" class="orange--text"></v-progress-circular>
      </div>
    </div>

    <div v-if="!loading" >

      <v-layout style="margin: auto;padding:auto; margin-right: 0px;" row wrap>

        <div style="text-align: right; margin-left: 10px;margin-bottom: 20px;">
          <v-btn style="margin: 0px;height:20px;font-size: 10px;" v-on:click.native="wijzigvolgnrClicked" :disabled="loading">wijzig volgnr</v-btn>
        </div>

          <v-flex xs12 >
            <div style="text-align: left; margin-left: 10px;">
              {{werfnr}}
            </div>
            <div style="text-align: left; margin-left: 10px;">
              <v-text-field style="margin: 0px;"
                  hide-details
                  v-model="werfnaam"
                  @input="dataGewijzigd"
                ></v-text-field>
            </div>
          </v-flex>

          <v-flex xs12 ><br></v-flex>
          <v-flex xs12 v-if="aantalmachines!=0" style="text-align: left; margin-left: 10px;font-weight: bold;">Materieel:</v-flex>

            <table v-if="aantalmachines!=0" style="margin-left: 10px;">
            <tbody>
              <tr v-for="item in machines" @click="clickedMachine(item)">
                <td>{{item.soortID}}.{{item.volgnr}}</td>
                <td>{{item.omschr}}</td>
              </tr>
            </tbody>
          </table>




      </v-layout>










    </div>

    </div>





    <v-layout row justify-center style="position: relative;">
      <v-dialog v-model="showSaveDialog" width="350px" absolute persistent>
        <v-card>
          <v-card-title>
            <div class="headline">Wijzigingen opslaan?</div>
          </v-card-title>
          <v-card-actions>
            <v-btn dark @click.native="saveDialogOpslaan">Opslaan</v-btn>
            <v-btn dark @click.native="saveDialogNietOpslaan">Niet opslaan</v-btn>
            <v-btn dark @click.native="saveDialogAnnuleren">Annuleren</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>



      <v-layout row justify-center style="position: relative;">
        <v-dialog v-model="showVerwijderDialog" width="350px" absolute persistent>
          <v-card style="background-color: red;">
            <v-card-title>
              <div class="headline white--text">Werf verwijderen?</div>
            </v-card-title>
            <v-card-actions>
              <v-btn dark @click.native="showVerwijderDialog = false">Annuleren</v-btn>
              <v-spacer></v-spacer>
              <v-btn dark @click.native="verwDialogVerwijderen">Verwijderen</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-layout>

      <v-layout row justify-center style="position: relative;">
        <v-dialog v-model="showVerwijderDialogMislukt" width="350px" absolute persistent>
          <v-card style="background-color: orange;">
            <v-card-title>
              <div class="headline white--text">Fout: werf bevat materieel</div>
            </v-card-title>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn dark @click.native="showVerwijderDialogMislukt = false">OK</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-layout>


      <v-layout row justify-center style="position: relative;">
        <v-dialog v-model="showWijzigVolgnrDialog" width="350px" absolute persistent>
          <v-card >
            <v-card-title>
              <div class="headline">Wijzig werfnummer</div>
            </v-card-title>
            <v-card-text>
              <v-text-field v-model="werfnrnieuw" label="werfnummer" required></v-text-field>
              <div class="red--text" v-if="TErrorShow">{{TErrorWijzigVolgnr}}</div>
            </v-card-text>
            <v-card-actions>
              <v-btn dark @click.native="showWijzigVolgnrDialog = false">Annuleren</v-btn>
              <v-spacer></v-spacer>
              <v-btn dark @click.native="WijzigVolgnrDialogClicked">OK</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-layout>





</div>
</template>

<script>
import datareq from './datareq.js'
import functions from './functions.js'
import Jspdf from 'jspdf'
import autotable from 'jspdf-autotable'
  export default {
    components: {
      datareq,
      functions,
      Jspdf,
      autotable
    },
    created: function () {
      this.$bus.$on('laadWervenDetail', this.laden)
    },
    data () {
      return {
        machines: [],
        aantalmachines: 0,
        loading: false,
        datagew: false,
        werfnr: '',
        werfnrorigineel: '',
        werfnrnieuw: '',
        werfnaam: '',
        showSaveDialog: false,
        showVerwijderDialog: false,
        showVerwijderDialogMislukt: false,
        showWijzigVolgnrDialog: false,
        TErrorWijzigVolgnr: '',
        TErrorShow: false
      }
    },
    methods: {
      resetAll: function () {
        this.werfnr = ''
        this.werfnrnieuw = ''
        this.werfnaam = ''
        this.werfnrorigineel = ''
        this.aantalmachines = 0
      },
      herladen: function () {
        this.laden([{werfnr: this.werfnr, werfnaam: this.werfnaam}])
      },
      laden: function (data) {
        this.resetAll()
        this.datagew = false
        this.loading = true

        var werfnr = data[0].werfnr
        var werfnaam = data[0].werfnaam

        this.werfnr = werfnr
        this.werfnrorigineel = werfnr
        this.werfnrnieuw = werfnr
        this.werfnaam = werfnaam

        datareq.getData('GetMachinesVanWerf', {wnr: werfnr}, this.jsonWerfMachinesReceived)
      },
      dataGewijzigd: function () {
        if(!this.loading) {
          this.datagew = true
        }
      },
      wijzigvolgnrClicked: function () {
        this.showWijzigVolgnrDialog = true
      },
      clickedMachine: function (obj) {
        this.$bus.$emit('laadMachineDetailGlobal',{sid: obj.soortID, vid: obj.volgnr})
      },
      jsonWerfMachinesReceived: function (data) {
        var status = data.status
        if (status === 'OK') {
          this.receivedCounter = this.receivedCounter + 1
          var d = data.data
          this.machines = []

          for (var s of d) {
            var n = {soortenvolgnr: s.soortID + '.' + s.volgnr, soortID: s.soortID, volgnr: s.volgnr, omschr: s.omschr}
            this.machines.push(n)
          }

          this.aantalmachines = d.length
        } else {
        }
        this.loading = false
        this.datagew = false
      },
      terugClicked: function () {
        if (this.datagew) {
          this.showSaveDialog = true
        } else {
          this.$emit('backWerven')
        }
      },
      afdrukkenClicked: function () {
        var res = this.machines

        var columns = [{title: "soort&volgnr", dataKey: "soortenvolgnr"}, {title: "omschrijving", dataKey: "omschr"}];
        var rows = [];
        for (var i = 0; i < res.length; i++) {
          rows.push(res[i]);
        }
        // Only pt supported (not mm or in)
        var doc = new Jspdf('p', 'pt', 'a4');
        doc.text('Werf',95, 60 );
        doc.addImage(functions.getVLBLogo(), 'JPEG', 40, 40, 48, 30);

        var currentdate = new Date();
        var datetime = "Datum afdruk: " + currentdate.getDate() + "/"
                + (currentdate.getMonth()+1)  + "/"
                + currentdate.getFullYear() + " - "
                + currentdate.getHours() + ":"
                + currentdate.getMinutes();

        doc.setFontSize(8);
        doc.text(datetime,550, 60 ,'right')


        var mL = 40 // marge links
        var mLR = 160 // marge van links voor vorstvrij, defect, ...
        var mT = 90 // marge tot boven
        var spacer = 50
        doc.setFontType("bold")
        doc.text("Werfnr:", mL, mT)
        doc.setFontType("normal")
        doc.text(this.werfnr, mL + spacer, mT)
        doc.setFontType("bold")
        doc.text("Naam:", mLR, mT, 'right')
        doc.setFontType("normal")
        doc.text(this.werfnaam, mLR + 30, mT)
        doc.setFontSize(12)
        doc.setFontType("bold")
        doc.text("Materieel:", mL, mT + 30)

        doc.setFontSize(8);

        var header = function (data) {
        }

        var totalPagesExp = "{total_pages_count_string}";
        var footer = function (data) {
        var str = "Pagina " + data.pageCount
        if (typeof doc.putTotalPages === 'function') {
            str = str + " van " + totalPagesExp
        }
        doc.text(str, data.settings.margin.left, doc.internal.pageSize.height - 30)
        }


        var options = {
          addPageContent: header,
            startY: 135,
            styles: {
               // font: 'courier',
                fillStyle: 'DF',
                lineColor: [128, 128, 128],
                fontSize: 7,
                lineWidth: 0,
                overflow: 'linebreak'
            },
            headerStyles: {
                fillColor: [200, 200, 200],
                fontSize: 7,
                cellPadding : 2
            },
            bodyStyles: {
                fillColor: [255, 255, 255],
                textColor: 0
            },
            alternateRowStyles: {
                fillColor: [255, 255, 255]
            },
            columnStyles: {
            },
            vorigesoort : "",
            drawRow: function (row, data) {
                doc.setFontStyle('bold')
                doc.setFontSize(10)
            },
/*
            <td>{{item.soortID}}.{{item.volgnr}}</td>
            <td>{{item.omschr}}</td>
            */
            createdCell: function (cell, data) {
                if (data.column.dataKey === 'soortenvolgnr') {
                    cell.styles.halign = 'left'
                } else if (data.column.dataKey === 'omschr') {
                    cell.styles.halign = 'left'
                    //cell.text = ""
                }
            },
            addPageContent: footer
        }


        doc.autoTable(columns, rows, options)

        if (typeof doc.putTotalPages === 'function') {
            doc.putTotalPages(totalPagesExp)
        }
        doc.save('werf.pdf')
      },
      verwDialogVerwijderen: function () {
        datareq.getData('VerwijderWerf', {werfnr: this.werfnrorigineel}, this.jsonWerfVerwijderd)
      },
      jsonWerfVerwijderd: function (data) {
        var status = data.status
        if (status === 'OK') {
        } else {
        }
        this.showVerwijderDialog = false
        this.$emit('backWerven')
      },
      opslaanClicked: function () {
        this.sluitennaopslaan = false
        this.werfOpslaan()
      },
      nieuwePrimaryKeysWerf: function (data) {
        var status = data.status
        var d = data.data
        if (status === 'OK') {
          if(d === 1) {
            this.showWijzigVolgnrDialog = false
            this.werfnr = this.werfnrnieuw
            this.herladen()
            // this.laden([{sid: this.nieuweMachineSoort.soortID, vid: this.nieuweVolgnr}])
          } else if (d === 2 || d === 0) {
            this.TErrorWijzigVolgnr = 'Fout.'
            this.TErrorShow = true
          }
        } else {
        }
      },
      WijzigVolgnrDialogClicked: function () {
          if(this.werfnrnieuw != '') {
              datareq.getData('WijzigPrimaryKeysWerf', {werfID: this.werfnr, nieuwewerfID: this.werfnrnieuw}, this.nieuwePrimaryKeysWerf)
          } else {
            this.TErrorWijzigVolgnr = 'Vul geldig werfnummer in.'
            this.TErrorShow = true
          }
      },
      verwijderenClicked: function () {
        if(this.aantalmachines == 0) {
          this.showVerwijderDialog = true
        } else {
          this.showVerwijderDialogMislukt = true
        }
      },
      jsonWerfOpslaan: function () {
        this.datagew = false
        this.loading = false
        if(this.sluitennaopslaan) {
          this.showSaveDialog = false
          this.$emit('backWerven')
        } else {
          this.herladen()
        }
      },
      werfOpslaan: function () {
        this.loading = true
        var m = {}

        m.werfnr = this.werfnr
        m.werfnaam = this.werfnaam

        datareq.getData('WerfOpslaan', m, this.jsonWerfOpslaan)
      },
      saveDialogOpslaan: function () {
        this.sluitennaopslaan = true
        this.werfOpslaan()
      },
      saveDialogNietOpslaan: function () {
        this.showSaveDialog = false
        this.$emit('backWerven')
      },
      saveDialogAnnuleren: function () {
        this.showSaveDialog = false
      }
    }
  }
</script>

<style lang="stylus">
  @import './stylus/main'

</style>
<style scoped>

tr {
  cursor: pointer;
  text-align: left;
  white-space: pre-wrap;
}

tr:nth-child(odd) {
  background-color: #f2f2f2;
  color: #000000;
}

tr:hover {
  background-color: #cde9ef;
  cursor: pointer;
}

td {
  min-width: 10px;
  padding: 5px 5px;
  margin: 0px;
  border: 1px solid black;
}


</style>



// WEBPACK FOOTER //
// wervendetail.vue?6a4ff24a